module.exports = __webpack_public_path__ + "static/media/icon_lock.8bada629.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_lock.svg
// module id = 2417
// module chunks = 7